function filterCases() {
  const filterTerms = [...document.querySelectorAll("#taxonomy-filter")];
  const allCases = [
    ...document.querySelectorAll(".m-case-archive-overview__col"),
  ];
  //only to be used once
  const allCasesCopy = [
    ...document.querySelectorAll(".m-case-archive-overview__col"),
  ];
  const taxonomyNames = [
    ...document.querySelectorAll(".m-case-archive-overview__taxonomy"),
  ];
  const casesContainer = document.querySelector(
    ".m-case-archive-overview__container"
  );
  const noCasesMessage = `<h5 id="no-cases-message">Helaas zijn er geen cases die horen bij jouw zoekopdracht</h5>`;
  const loadMoreBtn = ` <div id="load-more-button-container"><button class="e-button e-cta-button load-more-btn">Bekijk meer</button></div>`;

  let filteredCasesArray = [];
  let filteredTermsArr = [];

  function initFilter() {
    ///initialise eventlisteners on filters
    filterTerms.forEach((term) => {
      term.addEventListener("click", function (el) {
        //style text on click
        styleCheckBox(term, el.target);
        //handle filtering on click
        handleClickOnTerm(term);
      });
    });

    ////initialise eventlisteners on taxonomy names
    taxonomyNames.forEach((taxonomy) => {
      // rotate arrow on init
      taxonomy.querySelector("svg").classList.add("-rotate-90-deg");
      // add eventlistener
      taxonomy.addEventListener("click", function () {
        //handle dropdown taxonomy on click
        handleClickOnTaxonomy(taxonomy);
      });
    });

    //updates front end of container if more than 9 cases
    updateCasesContainer(allCasesCopy, true);
  }

  function handleClickOnTerm(term) {
    //remove no cases message and styling if it was added to container before
    if (casesContainer.classList.contains("no-cases-message")) {
      casesContainer.classList.remove("no-cases-message");
      casesContainer.querySelector("#no-cases-message").remove();
    }
    //hide all cases on click
    hideAllCases();

    //find checked terms and add to array
    addTermstoFilteredTermsArray(filterTerms);

    //check for cases that match the checked terms
    addCasesToFilteredCasesArray();

    //unhide cases that matched the checked terms
    handleFiltering(filteredCasesArray);

    //update front end of container for amount of filtered cases
    updateCasesContainer(filteredCasesArray, false);

    if (filteredCasesArray.length === 0) {
      casesContainer.insertAdjacentHTML("beforeend", noCasesMessage);
      casesContainer.classList.add("no-cases-message");
    }
    //reset arrays
    filteredCasesArray = [];
    filteredTermsArr = [];
  }

  function hideAllCases() {
    allCases.forEach((item) => {
      item.classList.add("hide-element");
    });
  }

  function addTermstoFilteredTermsArray(filters) {
    ///find all checked boxes and add term name to array
    filters.forEach((filter) => {
      if (filter.querySelector("input").checked) {
        filteredTermsArr.push(filter.dataset.termName);
      }
    });
    ///remove duplicates
    filteredTermsArr = [...new Set(filteredTermsArr)];
  }

  function addCasesToFilteredCasesArray() {
    allCases.forEach((item) => {
      let filterMatchCount = 0;

      //loop as many times as length of filtered terms array
      for (let i = 0; i < filteredTermsArr.length; i++) {
        /// if any of the dataset properties contains the term name than increase count
        if (
          item.dataset.doelgroep.includes(filteredTermsArr[i]) ||
          item.dataset.toepassing.includes(filteredTermsArr[i]) ||
          item.dataset.product.includes(filteredTermsArr[i])
        ) {
          filterMatchCount++;
        }
      }
      /// if count is same as amount of filters, than add item to filtereed cases array
      if (filterMatchCount === filteredTermsArr.length) {
        filteredCasesArray.push(item);
      }
    });
  }

  function handleFiltering(items) {
    ///show items that have been filtered
    items.forEach((item) => {
      item.classList.remove("hide-element");
    });
  }

  function updateCasesContainer(items, initCall) {
    ///remove the button if it was already added and not initial page load
    if (
      document.querySelector("#load-more-button-container") &&
      initCall == false
    ) {
      document.querySelector("#load-more-button-container").remove();
    }
    //save the length of array
    const totalItems = items.length;
    //create array that will remove 9 items from itself on click of the load more button
    let hideItems = items;
    ///counter for amount of shown items
    let shownItems = 0;

    ///logic for first iteration
    if (hideItems.length > 9) {
      //with every click of the button add 9 to this
      shownItems = shownItems + 9;
      //create nwe array of items ot be hidden
      hideItems = hideItems.splice(9);
      //hide all items more than 9
      hideItems.forEach((item) => {
        item.classList.toggle("hide-element");
      });
      ///add load more btn to container
      casesContainer.insertAdjacentHTML(
        "afterend",
        ` <div id="load-more-button-container"> <div class="load-more-text"><p><span class="shown-items">${shownItems}</span> van <span class="total-items">${totalItems}</span> cases</p> <div class="load-more-bar"></div></div><button class="e-button e-cta-button load-more-btn">Bekijk meer</button></div>`
      );
      ///set load bar width
      setLoadBarWidth(shownItems, totalItems);
    }

    ///logic when there are more than 9 items and a button is created
    if (document.querySelector(".load-more-btn")) {
      ///event listener for load more btn
      document
        .querySelector(".load-more-btn")
        .addEventListener("click", function () {
          //if more than 9 items still exist create a loop to set their display to visible and remove them from
          //the array. Also update the counter and the width of the load bar
          if (hideItems.length > 9) {
            shownItems = shownItems + 9;
            for (let i = 0; i < 9; i++) {
              hideItems[i].classList.toggle("hide-element");
            }
            hideItems = hideItems.splice(9);
            document.querySelector(".shown-items").innerHTML = shownItems;
            setLoadBarWidth(shownItems, totalItems);
          } else {
            ////if no more than 9 items remain, show all items end remove btn
            hideItems.forEach((item) => {
              item.classList.toggle("hide-element");
            });
            document.querySelector("#load-more-button-container").remove();
          }
        });
    }
  }

  function setLoadBarWidth(shownItems, totalItems) {
    ///sets width of loadbar
    document.querySelector(".load-more-bar").style.width =
      (shownItems / totalItems) * 100 + "px";
  }

  function styleCheckBox(term, target) {
    let checkBox = term.querySelector("input");
    // toggle active state color on click
    term.querySelector("span").classList.toggle("active-state");
    //only change the checkbox checked property of not clicked on the box itself
    if (target != checkBox) {
      checkBox.checked = !checkBox.checked;
    }
  }

  function handleClickOnTaxonomy(target) {
    //rotate to one side on click
    target.querySelector("svg").classList.toggle("-rotate-90-deg");
    target.querySelector("svg").classList.toggle("rotate-90-deg");
    //toggle hide term elements on click
    target.parentElement
      .querySelector(".m-case-archive-overview__terms")
      .classList.toggle("hide-element");
  }

  initFilter();
}

if (document.querySelector(".m-case-archive-overview")) {
  filterCases();
}
